function toggleOffers() {
  const details = document.getElementById("offerDetails");
  const icon = document.getElementById("offerToggleIcon");

  const arrowUp = `
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
      <path d="M1.5893 6.72929C1.41417 6.90272 1.1776 7 0.931145 7C0.684667 7 0.44815 6.90272 0.272999 6.72929C0.186528 6.64413 0.117855 6.54262 0.070981 6.43067C0.024107 6.31872 0 6.19857 0 6.0772C0 5.95583 0.024107 5.83568 0.070981 5.72373C0.117855 5.61178 0.186528 5.51027 0.272999 5.42511L5.53281 0.270282C5.70836 0.0971031 5.94504 0 6.19164 0C6.43823 0 6.67491 0.0971031 6.85046 0.270282L12.1103 5.42511C12.1967 5.51027 12.2654 5.61178 12.3123 5.72373C12.3592 5.83568 12.3833 5.95583 12.3833 6.0772C12.3833 6.19857 12.3592 6.31872 12.3123 6.43067C12.2654 6.54262 12.1967 6.64413 12.1103 6.72929C11.9351 6.90272 11.6986 7 11.4521 7C11.2056 7 10.9691 6.90272 10.794 6.72929L6.18962 2.5018L1.5893 6.72929Z" fill="#A15106"/>
    </svg>
  `;

  const arrowDown = `
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
      <path d="M11.4107 0.270707C11.5858 0.0972844 11.8224 0 12.0688 0C12.3153 0 12.5518 0.0972844 12.727 0.270707C12.8135 0.355868 12.8821 0.457377 12.929 0.569327C12.9759 0.681277 13 0.801432 13 0.9228C13 1.04417 12.9759 1.16432 12.929 1.27627C12.8821 1.38822 12.8135 1.48973 12.727 1.57489L7.46719 6.72972C7.29164 6.9029 7.05496 7 6.80836 7C6.56177 7 6.32509 6.9029 6.14954 6.72972L0.889734 1.57489C0.80326 1.48973 0.734587 1.38822 0.687713 1.27627C0.640838 1.16432 0.616699 1.04417 0.616699 0.9228C0.616699 0.801432 0.640838 0.681277 0.687713 0.569327C0.734587 0.457377 0.80326 0.355868 0.889734 0.270707C1.06488 0.0972844 1.3014 0 1.54788 0C1.79436 0 2.03088 0.0972844 2.20603 0.270707L6.81038 4.4982L11.4107 0.270707Z" fill="#A15106"/>
    </svg>
  `;
 const isVisible = window.getComputedStyle(details).display === "block";
    if (isVisible) {
    details.style.display = "none";
    icon.innerHTML = arrowUp;
  } else {
    details.style.display = "block";
    icon.innerHTML = arrowDown;
  }
  // if (details.style.display === "block") {
  //       details.style.display = "none";
  //   icon.innerHTML = arrowUp;

  // } else {
  //      details.style.display = "block";
  //   icon.innerHTML = arrowDown;
  // }
}


function copyCode(code) {
  navigator.clipboard.writeText(code).then(() => {
    // alert(`Code "${code}" copied to clipboard!`);
  });
}

// // Gold Rate Calculate Start
// let Goldratecstm = parseFloat(document.querySelector(".get_gold_price_cstm").innerText) || 0;
// let metadiamondWeight = parseFloat(document.querySelector(".diamond_weight").innerText) || 0;
// let nodiamond = parseFloat(document.querySelector(".no-of-diamonds").innerText) || 0;
// let diamondGM = metadiamondWeight / 5; 
// let rate24k = Goldratecstm;
// // alert(diamondGM)
// let goldRates = {
//   "24K": rate24k,
//   "22K": rate24k * (22/24),   // 91.67%
//   "18K": rate24k * 0.75,      // 75%
//   "14K": rate24k * 0.585      // 58.5%
// };

// // --------------------------
// // FUNCTION: Price Calculation
// // --------------------------
// // --------------------------
// // FUNCTION: Price Calculation
// // --------------------------
// function updatePriceBreakup() {

//   // --------------------------
//   // VARIANT IMAGE UPDATE
//   // --------------------------
//   let selectedVariant = document.querySelector('input[data-variant-image]:checked') 
//                      || document.querySelector('input[data-variant-image][name="id"]'); 
//     let variantSKU = selectedVariant.getAttribute('data-variant-sku');

//   if (selectedVariant) {
//     let variantImage = selectedVariant.getAttribute('data-variant-image');
//     // console.log("Variant Image URL:", variantSKU);

//     // Main product image replace (optional)
//     let mainImg = document.querySelector('.product__media img, .product-gallery img'); 
//     if (mainImg && variantImage) {
//       mainImg.src = variantImage;
//     }

//     // ✅ Summary card ring image replace
//     let ringImg = document.querySelector('.product-summary-card .ring-image img');
//     if (ringImg && variantImage) {
//       ringImg.src = variantImage;
//     }
//   }

//   // --------------------------
//   // RING SIZE HANDLING (safe)
//   // --------------------------
//   let text = "Free Size"; // default if ring size not available
//   let finalWeight;
//   let metsmetalweight = parseFloat(document.querySelector(".meta_weight_cstm")?.innerText) || 0;
//   let baseWeight = metsmetalweight;

// let select = document.querySelector('.product-custom-option.admin__control-select');
// if (select) {
//   text = select.options[select.selectedIndex].text.trim();
//   finalWeight = baseWeight;

//   let num = parseInt(text, 10);
//   if (!isNaN(num)) {
//     if (num > 12) {
//       finalWeight = baseWeight + ((num - 12) * 0.03); 
//     } else if (num < 12) {
//       finalWeight = baseWeight - ((12 - num) * 0.03); 
//     }
//   }
// } else {

//   finalWeight = baseWeight;
// }


//   if (finalWeight < 1) {
//     finalWeight = baseWeight; 
//   }

//   // MAKING CHARGES
//   let makingCharge = finalWeight > 2 ? finalWeight * 750 : 1500;

//   // GOLD KARAT SE RATE
//   let goldOption = document.querySelector('.get-gold-karat input[type="radio"]:checked');
//   let goldText = "";
//   let goldRate = 0;

//   if (goldOption) {
//     let labelGold = document.querySelector('label[for="' + goldOption.id + '"]');
//     goldText = labelGold.innerText.trim();  
//     goldText = goldText.replace(/[^0-9K]/gi, "").toUpperCase();

//     if (goldRates[goldText]) {
//       goldRate = goldRates[goldText];
//       console.log('ssswwjsjsjjsjs', goldRates[goldText])
//     } else {
//       goldRate = 5928.975; // fallback default
//     }
//   }

//   let netGoldWeight = finalWeight - diamondGM;
//   if (netGoldWeight < 0) netGoldWeight = 0;

//   let goldPrice = netGoldWeight * goldRate;

//   // DIAMOND QUALITY OPTION
//   let diamondOption = document.querySelector('.get-diamond-quality input[type="radio"]:checked');
//   let quality = "";
//   let diamondPrice = 0;

//   let diamondWeight = metadiamondWeight;

//   if (diamondOption) {
//     quality = diamondOption.nextElementSibling.querySelector('span:first-child').innerText.trim();
//     diamondPrice = parseFloat(diamondOption.getAttribute('price')) || 0;
//     diamondPrice = diamondPrice * diamondWeight; 
//   }

//   // TOTAL PRICE (GST Inclusive)
//   // TOTAL PRICE (GST Inclusive)
//   let totalPrice = goldPrice + makingCharge + diamondPrice;
//   let subtotal = totalPrice / 1.03;  
//   let gst = subtotal * 0.03;         

//   // ✅ Diamond price me se GST minus karo
//   let updatedDiamondPrice = diamondPrice - gst;
//   if (updatedDiamondPrice < 0) updatedDiamondPrice = 0;

//   // ✅ Ab total price me updated diamond price use karo
//   let totalWithGst = goldPrice + makingCharge + updatedDiamondPrice + gst;


//   // --------------------------
//   // UPDATE PRICE BREAKUP LIST
//   // --------------------------
//   let metalEl   = document.querySelector('.price-breakup-list li:nth-child(2) span');
//   let diamondEl = document.querySelector('.price-breakup-list li:nth-child(3) span');
//   let makingEl  = document.querySelector('.price-breakup-list li:nth-child(4) span');
//   let gstEl     = document.querySelector('.price-breakup-list li:nth-child(5) span');
//   let totalEl   = document.querySelector('.price-breakup-list li:nth-child(6) span');

//   if (metalEl)   metalEl.innerText   = "₹" + goldPrice.toFixed(2);
//   if (diamondEl) diamondEl.innerText = "₹" + updatedDiamondPrice.toFixed(2);
//   if (makingEl)  makingEl.innerText  = "₹" + makingCharge.toFixed(2);
//   if (gstEl)     gstEl.innerText     = "₹" + gst.toFixed(2);
//   if (totalEl)   totalEl.innerText   = "₹" + totalWithGst.toFixed(2);

//   // --------------------------
//   // UPDATE PRODUCT DETAILS UL
//   // --------------------------
//   let styleNoEl     = document.querySelector('.product-details.product-details_bs li:nth-child(1) span');
//   let ringSizeEl    = document.querySelector('.product-details.product-details_bs li:nth-child(2) span');
//   let metalWeightEl = document.querySelector('.product-details.product-details_bs li:nth-child(3) span');
//   let grossWeightEl = document.querySelector('.product-details.product-details_bs li:nth-child(4) span');
//   if (styleNoEl) styleNoEl.innerText = variantSKU; 
//   if (ringSizeEl)    ringSizeEl.innerText    = text;                          
//   if (metalWeightEl) metalWeightEl.innerText = netGoldWeight.toFixed(3) + "g"; 
//   if (grossWeightEl) grossWeightEl.innerText = finalWeight.toFixed(3) + "g";   

//   // --------------------------
//   // UPDATE ACCORDION BODY SPANS
//   // --------------------------
//   let karatageEl    = document.querySelector('span[Karatage] .name_type');
//   let metalColorEl  = document.querySelector('span[Metal_Color] .name_type');
//   let accMetalWeightEl = document.querySelector('span[Metal_Weight] .name_type');
//   let sizeEl        = document.querySelector('span[Metal_size] .name_type');
//   let metalNameEl   = document.querySelector('span[Metal_name] .name_type');

//   let ClarityEl    = document.querySelector('span[Clarity] .name_type');
//   let TotalWeightEl  = document.querySelector('span[Total_Weight] .name_type');
//   let DimaondQTY    = document.querySelector('span[DiamondQTY] .name_type');
//   if (DimaondQTY)       DimaondQTY.innerText       = nodiamond || "—";
//   if (ClarityEl)       ClarityEl.innerText       = quality || "—";
//   if (TotalWeightEl)   TotalWeightEl.innerText   = diamondWeight || "—";
//   if (karatageEl)      karatageEl.innerText      = goldText || "—";

//   if (metalColorEl) {
//     let colorOption = document.querySelector('fieldset.variant-option--swatches input[type="radio"]:checked');
//     if (colorOption) {
//       metalColorEl.innerText = colorOption.value.trim();   // e.g. "Yellow Gold"
//     } else {
//       metalColorEl.innerText = "—"; 
//     }
//   }
//   if (accMetalWeightEl) accMetalWeightEl.innerText = netGoldWeight.toFixed(3) + "g";
//   if (sizeEl)           sizeEl.innerText           = text;
//   if (metalNameEl)      metalNameEl.innerText      = "Gold";
// }

// // --------------------------
// // ON PAGE LOAD (with delay + default selection fix)
// // --------------------------
// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(function(){
//     // Ensure at least one gold karat is checked
//     let goldOption = document.querySelector('.get-gold-karat input[type="radio"]:checked');
//     if (!goldOption) {
//       let firstGold = document.querySelector('.get-gold-karat input[type="radio"]');
//       if (firstGold) firstGold.checked = true;
//     }

//     // Ensure at least one diamond quality is checked
//     let diamondOption = document.querySelector('.get-diamond-quality input[type="radio"]:checked');
//     if (!diamondOption) {
//       let firstDiamond = document.querySelector('.get-diamond-quality input[type="radio"]');
//       if (firstDiamond) firstDiamond.checked = true;
//     }

//     // Ensure select box has a valid value
//     let select = document.querySelector('.product-custom-option.admin__control-select');
//     if (select && select.selectedIndex < 0) {
//       select.selectedIndex = 0;
//     }

//     // Call price calculation
//     updatePriceBreakup();

//     // Dispatch change event for pre-selected inputs
//     document.querySelectorAll(
//       '.get-gold-karat input[type="radio"]:checked, .get-diamond-quality input[type="radio"]:checked, .product-custom-option.admin__control-select'
//     ).forEach(function (el) {
//       el.dispatchEvent(new Event("change"));
//     });

//   }, 500);
// });

// // --------------------------
// // ON CHANGE EVENTS
// // --------------------------
// document.querySelectorAll('.cstm-variant-type-dr').forEach(function(block) {
//   block.addEventListener('click', function() {
//     setTimeout(updatePriceBreakup, 100);
//   });
// });
// document.querySelectorAll('.get-gold-karat input[type="radio"], .get-diamond-quality input[type="radio"], .product-custom-option.admin__control-select').forEach(function(el) {
//   el.addEventListener('change', updatePriceBreakup);
// });

// window.addEventListener('DOMContentLoaded', function () {
//     const element = document.querySelector('.cstm-variant-type-dr');
//     if (element) {
//         element.click();
//     }
// });


let Goldratecstm = parseFloat(document.querySelector(".get_gold_price_cstm").innerText) || 0;
let metadiamondWeight = parseFloat(document.querySelector(".diamond_weight").innerText) || 0;
let nodiamond = parseFloat(document.querySelector(".no-of-diamonds").innerText) || 0;
let diamondGM = metadiamondWeight / 5; 
let rate24k = Goldratecstm;
// alert(diamondGM)
let goldRates = {
  "24K": rate24k,
  "22K": rate24k * (22/24),   // 91.67%
  "18K": rate24k * 0.75,      // 75%
  "14K": rate24k * 0.585,      // 58.5%
  "10K": rate24k * 0.417,
  "9K": rate24k * 0.375,
};

// --------------------------
// FUNCTION: Price Calculation
// --------------------------
// --------------------------
// FUNCTION: Price Calculation
// --------------------------
function updatePriceBreakup() {

  // --------------------------
  // VARIANT IMAGE UPDATE
  // --------------------------
  let selectedVariant = document.querySelector('input[data-variant-image]:checked') 
                     || document.querySelector('input[data-variant-image][name="id"]'); 
    let variantSKU = selectedVariant.getAttribute('data-variant-sku');

  if (selectedVariant) {
    let variantImage = selectedVariant.getAttribute('data-variant-image');
    // console.log("Variant Image URL:", variantSKU);

    // Main product image replace (optional)
    let mainImg = document.querySelector('.product__media img, .product-gallery img'); 
    if (mainImg && variantImage) {
      mainImg.src = variantImage;
    }

    // ✅ Summary card ring image replace
    let ringImg = document.querySelector('.product-summary-card .ring-image img');
    if (ringImg && variantImage) {
      ringImg.src = variantImage;
    }
  }

  // --------------------------
  // RING SIZE HANDLING (safe)
  // --------------------------
  let text = "Free Size"; // default if ring size not available
  let finalWeight;
  let metsmetalweight = parseFloat(document.querySelector(".meta_weight_cstm")?.innerText) || 0;
  let baseWeight = metsmetalweight;

let select = document.querySelector('.product-custom-option.admin__control-select');
if (select) {
  text = select.options[select.selectedIndex].text.trim();
  finalWeight = baseWeight;

  let num = parseInt(text, 10);
  if (!isNaN(num)) {
    if (num > 12) {
      finalWeight = baseWeight + ((num - 12) * 0.03); 
    } else if (num < 12) {
      finalWeight = baseWeight - ((12 - num) * 0.03); 
    }
  }
} else {

  finalWeight = baseWeight;
}


  if (finalWeight < 1) {
    finalWeight = baseWeight; 
  }

  // MAKING CHARGES
  let makingCharge = finalWeight > 1.33 ? finalWeight * 1500 : 2000;

  // GOLD KARAT SE RATE
  let goldOption = document.querySelector('.get-gold-karat input[type="radio"]:checked');
  let goldText = "";
  let goldRate = 0;

  if (goldOption) {
    let labelGold = document.querySelector('label[for="' + goldOption.id + '"]');
    goldText = labelGold.innerText.trim();  
    goldText = goldText.replace(/[^0-9K]/gi, "").toUpperCase();

    if (goldRates[goldText]) {
      goldRate = goldRates[goldText];
      console.log('ssswwjsjsjjsjs', goldRates[goldText])
    } else {
      goldRate = 5928.975; // fallback default
    }
  }

  let netGoldWeight = finalWeight - diamondGM;
  if (netGoldWeight < 0) netGoldWeight = 0;

  let goldPrice = netGoldWeight * goldRate;

  // DIAMOND QUALITY OPTION
  let diamondOption = document.querySelector('.get-diamond-quality input[type="radio"]:checked');
  let quality = "";
  let diamondPrice = 0;

  let diamondWeight = metadiamondWeight;

  if (diamondOption) {
    quality = diamondOption.nextElementSibling.querySelector('span:first-child').innerText.trim();
    diamondPrice = parseFloat(diamondOption.getAttribute('price')) || 0;
    diamondPrice = diamondPrice * diamondWeight; 
  }

  // TOTAL PRICE (GST Inclusive)
let totalPrice = goldPrice + makingCharge + diamondPrice;  
let gst = totalPrice * 0.03;       // 3% GST on total
let totalWithGst = totalPrice + gst;
     

  // --------------------------
  // UPDATE PRICE BREAKUP LIST
  // --------------------------
let metalEl   = document.querySelector('.price-breakup-list li:nth-child(2) span');
let diamondEl = document.querySelector('.price-breakup-list li:nth-child(3) span');
let makingEl  = document.querySelector('.price-breakup-list li:nth-child(4) span');
let totalEl   = document.querySelector('.price-breakup-list li:nth-child(5) span');
let gstEl     = document.querySelector('.price-breakup-list li:nth-child(6) span');
let grandEl   = document.querySelector('.price-breakup-list li:nth-child(7) span');

// ✅ Calculate total without GST
let total = goldPrice + diamondPrice + makingCharge;

if (metalEl)   metalEl.innerText   = "₹" + goldPrice.toFixed(2);
if (diamondEl) diamondEl.innerText = "₹" + diamondPrice.toFixed(2);
if (makingEl)  makingEl.innerText  = "₹" + makingCharge.toFixed(2);
if (totalEl)   totalEl.innerText   = "₹" + total.toFixed(2);
if (gstEl)     gstEl.innerText     = "₹" + gst.toFixed(2);

// ✅ Grand Total (Total + GST)
let grandTotal = total + gst;
console.log('Grand Total:', grandTotal);

if (grandEl)   grandEl.innerText   = "₹" + grandTotal.toFixed(2);

  // --------------------------
  // UPDATE PRODUCT DETAILS UL
  // --------------------------
  let styleNoEl     = document.querySelector('.product-details.product-details_bs li:nth-child(1) span');
  let ringSizeEl    = document.querySelector('.product-details.product-details_bs li:nth-child(2) span');
  let metalWeightEl = document.querySelector('.product-details.product-details_bs li:nth-child(3) span');
  let grossWeightEl = document.querySelector('.product-details.product-details_bs li:nth-child(4) span');
  if (styleNoEl) styleNoEl.innerText = variantSKU; 
  if (ringSizeEl)    ringSizeEl.innerText    = text;                          
  if (metalWeightEl) metalWeightEl.innerText = netGoldWeight.toFixed(3) + "g"; 
  if (grossWeightEl) grossWeightEl.innerText = finalWeight.toFixed(3) + "g";   

  // --------------------------
  // UPDATE ACCORDION BODY SPANS
  // --------------------------
  let karatageEl    = document.querySelector('span[Karatage] .name_type');
  let metalColorEl  = document.querySelector('span[Metal_Color] .name_type');
  let accMetalWeightEl = document.querySelector('span[Metal_Weight] .name_type');
  let sizeEl        = document.querySelector('span[Metal_size] .name_type');
  let metalNameEl   = document.querySelector('span[Metal_name] .name_type');

  let ClarityEl    = document.querySelector('span[Clarity] .name_type');
  let TotalWeightEl  = document.querySelector('span[Total_Weight] .name_type');
  let DimaondQTY    = document.querySelector('span[DiamondQTY] .name_type');
  if (DimaondQTY)       DimaondQTY.innerText       = nodiamond || "—";
  if (ClarityEl)       ClarityEl.innerText       = quality || "—";
  if (TotalWeightEl)   TotalWeightEl.innerText   = diamondWeight || "—";
  if (karatageEl)      karatageEl.innerText      = goldText || "—";

  if (metalColorEl) {
    let colorOption = document.querySelector('fieldset.variant-option--swatches input[type="radio"]:checked');
    if (colorOption) {
      metalColorEl.innerText = colorOption.value.trim();   // e.g. "Yellow Gold"
    } else {
      metalColorEl.innerText = "—"; 
    }
  }
  if (accMetalWeightEl) accMetalWeightEl.innerText = netGoldWeight.toFixed(3) + "g";
  if (sizeEl)           sizeEl.innerText           = text;
  if (metalNameEl)      metalNameEl.innerText      = "Gold";
}

// --------------------------
// ON PAGE LOAD (with delay + default selection fix)
// --------------------------
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function(){
    // Ensure at least one gold karat is checked
    let goldOption = document.querySelector('.get-gold-karat input[type="radio"]:checked');
    if (!goldOption) {
      let firstGold = document.querySelector('.get-gold-karat input[type="radio"]');
      if (firstGold) firstGold.checked = true;
    }

    // Ensure at least one diamond quality is checked
    let diamondOption = document.querySelector('.get-diamond-quality input[type="radio"]:checked');
    if (!diamondOption) {
      let firstDiamond = document.querySelector('.get-diamond-quality input[type="radio"]');
      if (firstDiamond) firstDiamond.checked = true;
    }

    // Ensure select box has a valid value
    let select = document.querySelector('.product-custom-option.admin__control-select');
    if (select && select.selectedIndex < 0) {
      select.selectedIndex = 0;
    }

    // Call price calculation
    updatePriceBreakup();

    // Dispatch change event for pre-selected inputs
    document.querySelectorAll(
      '.get-gold-karat input[type="radio"]:checked, .get-diamond-quality input[type="radio"]:checked, .product-custom-option.admin__control-select'
    ).forEach(function (el) {
      el.dispatchEvent(new Event("change"));
    });

  }, 500);
});

// --------------------------
// ON CHANGE EVENTS
// --------------------------
document.querySelectorAll('.cstm-variant-type-dr').forEach(function(block) {
  block.addEventListener('click', function() {
    setTimeout(updatePriceBreakup, 100);
  });
});
document.querySelectorAll('.get-gold-karat input[type="radio"], .get-diamond-quality input[type="radio"], .product-custom-option.admin__control-select').forEach(function(el) {
  el.addEventListener('change', updatePriceBreakup);
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {
    console.log("JS Loaded ✅");

    function getMetalRadios() {
      return document.querySelectorAll('.get-gold-karat .product-custom-option');
    }

    function getRoseGoldRadio() {
      // ✅ Only from Color option fieldset
      return document.querySelector('.cstm_variant_selector input[type="radio"][value="Rose Gold"]');
    }

    function selectFallbackOption(roseGoldRadio) {
      if (!roseGoldRadio) return;

      const allRadios = document.querySelectorAll(`input[type="radio"][name="${roseGoldRadio.name}"]`);
      const radiosArray = Array.from(allRadios);
      const roseIndex = radiosArray.indexOf(roseGoldRadio);

      let fallback = radiosArray[roseIndex - 1] || radiosArray[roseIndex + 1];
      if (fallback) {
        // ✅ Simulate real user click
        fallback.click(); // triggers variant change logic
        console.log("Fallback clicked:", fallback.value || fallback.getAttribute("aria-label"));
      }
    }

    function disableRoseGold() {
      const roseGoldRadio = getRoseGoldRadio();
      if (!roseGoldRadio) return;

      // if selected, pick fallback
      if (roseGoldRadio.checked) {
        selectFallbackOption(roseGoldRadio);
      }

      roseGoldRadio.checked = false;
      roseGoldRadio.disabled = true;
      roseGoldRadio.setAttribute("disabled", "disabled");

      const label = roseGoldRadio.closest("label");
      if (label) {
        label.classList.add("disabled-option");
        label.style.opacity = "0.5";
        label.style.pointerEvents = "none";
      }

      console.log("Rose Gold disabled ❌");
    }

    function enableRoseGold() {
      const roseGoldRadio = getRoseGoldRadio();
      if (!roseGoldRadio) return;

      roseGoldRadio.disabled = false;
      roseGoldRadio.removeAttribute("disabled");

      const label = roseGoldRadio.closest("label");
      if (label) {
        label.classList.remove("disabled-option");
        label.style.opacity = "1";
        label.style.pointerEvents = "auto";
      }

      console.log("Rose Gold enabled ✅");

      // ✅ FIX: re-enable Add to Cart button if it was disabled by Shopify
      const addToCartBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], button[name="add"], .product-form__submit');
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute("disabled");
        addToCartBtn.classList.remove("disabled");
      }
    }

    function toggleRoseGold() {
      const metalRadios = getMetalRadios();
      metalRadios.forEach(radio => {
        if (radio.checked) {
          const label = radio.closest('.get-gold-karat .field')?.querySelector('label span');
          const labelText = label?.innerText.trim();
          console.log("Selected Metal:", labelText);

          if (labelText === "9K") {
            disableRoseGold();
          } else if (labelText === "14K") {
            enableRoseGold();
          }
        }
      });
    }

    // Initial run
    toggleRoseGold();

    // Watch for changes on metal radios
    document.addEventListener("change", function(e) {
      if (e.target.closest('.get-gold-karat')) {
        toggleRoseGold();
      }
    });

    // MutationObserver → re-run when Shopify re-renders options
    const observer = new MutationObserver(() => {
      console.log("DOM updated, re-checking...");
      toggleRoseGold();
    });
    observer.observe(document.body, { childList: true, subtree: true });

  }, 3000);
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
  var priceElement = document.querySelector('product-price.text-block.custom-typography.custom-font-size.custom-color.text-left.custom.spacing-style span.price');
  if (priceElement) {
    priceElement.style.opacity = '1';
  }
  }, 1000);
});
document.addEventListener('DOMContentLoaded', function() {
    // Select all elements with the class .cstm-variant-type-dr
    const variantButtons = document.querySelectorAll('.cstm-variant-type-dr');

    // Loop through each button and add click event
    variantButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Add 'active-price' class to the price element
            const priceElement = document.querySelector('product-price.text-block.custom-typography.custom-font-size.custom-color.text-left.custom.spacing-style .price');
            if (priceElement) {
                priceElement.classList.add('active-price');
            }

            // Trigger clicks on all variant buttons after a short delay
            setTimeout(() => {
                variantButtons.forEach(el => el.click());
            }, 500); // 500ms delay, you can adjust
        });
    });
});




